<template>
    <div id="showBillingModal" class="modal fade" tabindex="-1" role="dialog" v-if="billing">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" style="border-radius: 6px !important">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">{{billing.title}}</h4>
                </div>
                <div class="modal-body" style="padding: 15px;">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th colspan="2">Dénomination de la prestation</th>
                                <th>Quantité</th>
                                <th>Prix unitaire</th>
                                <th>Date début</th>
                                <th>Date fin</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(detail,idx) in billing.detail">
                            <tr v-bind:key="idx">
                                <td colspan="2">{{detail.name}}</td>
                                <td>{{detail.quantity}}</td>
                                <td>{{detail.price}} €</td>
                                <td>{{detail.date_debut.split("-").reverse().join("/")}}</td>
                                <td>{{detail.date_fin.split("-").reverse().join("/")}}</td>
                            </tr>
                            <tr v-for="(enc,eidx) in detail.enc" v-bind:key="idx+'_'+eidx">
                                <td></td>
                                <td>{{enc.name}} {{enc.lastname}}</td>
                                <td>{{enc.quantity}}</td>
                                <td>{{enc.percentage.toFixed(2)}} %</td>
                                <td>{{enc.part}} €</td>
                                <td></td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="row">
                        <div class="col-md-6"><b>Remise : </b>{{billing.reduction?billing.reduction:"Aucune"}}</div>
                        <div class="col-md-6"><b>Débours : </b>{{billing.debours?billing.debours:"Aucun"}}</div>
                    </div>
                    <div><b>Client : </b>{{billing.customer.fullName}}</div>
                    <div><b>Introduction : </b>{{billing.introduction}}</div>
                    <div><b>Conclusion : </b>{{billing.conclusion}}</div>
                    <div><b>Commentaire : </b>{{billing.commentaire}}</div>
                    <div><b>Modalités de paiement : </b>{{billing.payment}}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Fermer</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "showBilling",
        data () {
            return {
               billing: null
            }
        },
        mounted () {
            globalEventBus.$on('showBilling', (billing)=>{
                this.billing = billing
                this.billing.detail=JSON.parse(this.billing.detail)
                this.$nextTick(()=>$("#showBillingModal").modal('show'))//after modal render
            })
        },
    }
</script>
